<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 16:48:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-16 11:47:21
 * @name: 表格
 * @Description: 表格 
 * @FilePath: \preSaleNafterSaleInside\project\src\components\public\table-normal.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="table">
    <!-- 标题 -->
    <slot name="title" />
    <!-- 头部按钮 -->
    <slot name="head" />
    <!-- bar条 -->
    <slot name="bar" />
    <!-- 表格 -->
    <slot name="table" />
    <!-- 分页器区域 -->
    <slot name="pagination" />
  </div>
</template>
<script>
export default {
  name: "tableNormal",
};
</script>
<style lang="scss" scoped>
.table {
  margin: 30px 0;
  border: 1px solid $Vars-border-first-color;
  box-sizing: border-box;
  @extend .et-flex-column-normal;
  .title {
    @extend .et-flex;
    padding: 20px 30px;
    font-size: $Vars-font-title-size;
  }
  .head {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding: 0 20px;
    @extend .et-flex-start;
    background: #f6f6f6;
    border-bottom: 1px solid $Vars-border-first-color;
  }
  .bar {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding: 0 20px;
    @extend .et-flex-start;
    background: $Vars-base-color-white;
    border-bottom: 1px solid $Vars-border-first-color;
    font-size: $Vars-font-miniContent-size;
    /deep/ * {
        margin-right: 30px;
    }
  }
  .pagination {
    margin-top: 20px;
    padding: 20px;
    align-self: flex-end;
  }
}
</style>